import { render, staticRenderFns } from "./HalamanUtamaPemilikSistem.vue?vue&type=template&id=b83c1d40&scoped=true&"
import script from "./HalamanUtamaPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./HalamanUtamaPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83c1d40",
  null
  
)

export default component.exports